'use client';

import React from 'react';
import PrivacyPolicy from '@/components/organisms/privacy-policy';

const TermsOfUseTastic = ({data}: any) => {
    const privacyPolicyData = data.data.dataSource;
    
    return <PrivacyPolicy isPrivacy={false} privacyPolicyData={privacyPolicyData} />
};

export default TermsOfUseTastic;